// Import local images //
import Anni1image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-classic-white-anniversary-de__56970.webp';
import Anni2image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-intimate-bedroom-decorated-f__56963.webp';
import Anni3image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56964.webp';
import Anni4image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56965.webp';
import Anni5image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56966.webp';
import Anni6image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56967.webp';
import Anni7image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56968.webp';
import Anni8image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56969.webp';
import Anni9image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-classic-white-anniversary-de__56970.webp';
import Anni10image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-intimate-bedroom-decorated-f__56963.webp';
import Anni11image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56964.webp';
import Anni12image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56965.webp';
import Anni13image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56966.webp';
import Anni14image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56967.webp';
import Anni15image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56968.webp';
import Anni16image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__the-style-is-candid-image-photography-with-natural__56969.webp';
import Anni17image from '../../assets/images/AnniverseryImages/AnnHomePageImages/freepik__35mm-film-photography-classic-white-anniversary-de__56970.webp';


const AnniversaryDataPackages = [
    {
      id: 1,
      title: "Romantic Anniversary Room Celebration",
      image: Anni1image,
      rating: 4.9,
      reviews: 165,
      currentPrice: 1999,
      originalPrice: 2199,
      discount: 9,
      description: "Beautiful home decoration with balloons and lights",
      subImage: [
        {
          imageOne: Anni9image,
          imageTwo: Anni10image,
          imageThree: Anni11image,
          imageFour: Anni12image,
        }
      ],
    },
    {
      id: 2,
      title: "Anniversary Bliss Setup",
      image: Anni2image,
      rating: 4.8,
      reviews: 185,
      currentPrice: 2099,
      originalPrice: 2499,
      discount: 16,
      description: "Elegant balloon arch with string lights",
      subImage: [
        {
          imageOne: Anni13image,
          imageTwo: Anni14image,
          imageThree: Anni14image,
          imageFour: Anni16image,
        }
      ]
    },
    {
      id: 3,
      title: "Red Anniversary Home Decor",
      image: Anni3image,
      rating: 4.4,
      reviews: 23,
      currentPrice: 2399,
      originalPrice: 2499,
      discount: 4,
      description: "Romantic red theme decoration with premium balloons",
      subImage: [
        {
          imageOne: Anni17image,
          imageTwo: Anni1image,
          imageThree: Anni12image,
          imageFour: Anni2image,
        }
      ]
    },
    {
      id: 4,
      title: "Golden Anniversary Celebration",
      image: Anni4image,
      rating: 4.6,
      reviews: 255,
      currentPrice: 2499,
      originalPrice: 2999,
      discount: 17,
      description: "Luxurious golden theme for special milestones",
      subImage: [
        {
          imageOne: Anni5image,
          imageTwo: Anni6image,
          imageThree: Anni7image,
          imageFour: Anni8image,
        }
      ]
    },

    {
        id: 5,
        title: "Silver Anniversary Decor",
        image: Anni5image,
        rating: 4.8,
        reviews: 185,
        currentPrice: 2099,
        originalPrice: 2499,
        discount: 16,
        description: "Elegant silver theme for 25th anniversary",
        subImage: [
          {
            imageOne: Anni8image,
            imageTwo: Anni9image,
            imageThree: Anni9image,
            imageFour: Anni10image,
          }
        ]
      },
      {
        id: 6,
        title: "Diamond Anniversary Setup",
        image: Anni6image,
        rating: 4.8,
        reviews: 185,
        currentPrice: 2099,
        originalPrice: 2499,
        discount: 16,
        description: "Premium diamond theme for 60th anniversary",
        subImage: [
          {
            imageOne: Anni11image,
            imageTwo: Anni12image,
            imageThree: Anni13image,
            imageFour: Anni14image,
          }
        ]
      },
      {
        id: 7,
        title: "Rose Gold Anniversary",
        image: Anni7image,
        rating: 4.8,
        reviews: 185,
        currentPrice: 2099,
        originalPrice: 2499,
        discount: 16,
        description: "Trendy rose gold theme decoration",
        subImage: [
          {
            imageOne: Anni14image,
            imageTwo: Anni15image,
            imageThree: Anni16image,
            imageFour: Anni17image,
          }
        ]
      },
      {
        id: 8,
        title: "Classic White Anniversary",
        image: Anni8image,
        rating: 4.8,
        reviews: 185,
        currentPrice: 2099,
        originalPrice: 2499,
        discount: 16,
        description: "Timeless white and gold theme",
        subImage: [
          {
            imageOne: Anni2image,
            imageTwo: Anni1image,
            imageThree: Anni3image,
            imageFour: Anni4image,
          }
        ]
      },
  ];

  export default AnniversaryDataPackages;
